import ComponentsFactory from '../../js/components-factory';
import Whois from './js/whois.component';

ComponentsFactory.getInstance().define('whois', Whois);

document.addEventListener('DOMContentLoaded', function () {
    ComponentsFactory.getInstance().init();
});
